import React, { useEffect, useState } from 'react';
import { Box, Divider, Loader, Text, Tooltip } from '@wix/design-system';
import s from './CodeGenStatus.module.scss';
import { DismissSmall, ConfirmSmall, InfoCircleSmall } from '@wix/wix-ui-icons-common';

// import { listMessages } from '@wix/ambassador-picasso-codegen-v1-message/http';
// import { Initiator } from '@wix/ambassador-picasso-codegen-v1-message/types';

const useCodeGenStatus = (httpClient, onWidgetAction, send) => {
  const [statusMessages, setStatusMessages] = useState([]);
  useEffect(() => {
    // if (httpClient) {
    //   httpClient.request(
    //     listMessages({
    //       initiator: Initiator.USER,
    //       paging: {
    //         limit: 10,
    //       },
    //     }),
    //   );
    // }
    setStatusMessages([{
      message: 'Adding a new feature.',
      status: 'inProgress'
    }]);
    setTimeout(() => {
      setStatusMessages([{
        message: 'Adding a new feature.',
        status: 'inProgress'
      }, {
        message: 'Adding another feature.',
        status: 'inProgress'
      }]);
      setTimeout(() => {
        setStatusMessages([{
          message: 'Feature added successfully',
          status: 'success'
        }, {
          message: 'Adding another feature.',
          status: 'inProgress'
        }]);
        setTimeout(() => {
          setStatusMessages([{
            message: 'Feature added successfully',
            status: 'success'
          }, {
            message: 'Added another feature.',
            status: 'success'
          }]);
          // in order to disable the user input for sending messages
          onWidgetAction(CODE_GEN_STATUS_WIDGET, {
            action: 'finished_codegen',
            value: true
          });

          // in order to write a save the response to the chat memory and write a meaningful answer to the user
          const strigifiedResponse = JSON.stringify({
            action: 'finished_codegen',
            data: [{
              message: 'Feature added successfully',
              status: 'success'
            }, {
              message: 'Added another feature.',
              status: 'success'
            }]
          });
          send(`<HIDDEN>${strigifiedResponse}</HIDDEN>`);
        }, 2000);
      }, 1000);
    }, 1000);
  }, [httpClient]);
  return {
    statusMessages
  };
};
export const CodeGenStatusWidget = _ref => {
  let {
    data: {
      message,
      id
    },
    context: {
      httpClient,
      onWidgetAction,
      send
    }
  } = _ref;
  const {
    statusMessages
  } = useCodeGenStatus(httpClient, onWidgetAction, send);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2,
    className: s.container
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: 2,
    align: "space-between"
  }, message && /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, message), id && /*#__PURE__*/React.createElement(Tooltip, {
    content: id
  }, /*#__PURE__*/React.createElement(InfoCircleSmall, null))), /*#__PURE__*/React.createElement(Divider, null), statusMessages.map((statusMessage, index) => /*#__PURE__*/React.createElement(Box, {
    key: index,
    direction: "vertical",
    gap: 2
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: 2,
    align: "space-between",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, statusMessage.message), statusMessage.status === 'inProgress' && /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }), statusMessage.status === 'success' && /*#__PURE__*/React.createElement(ConfirmSmall, {
    className: s.successIcon
  }), statusMessage.status === 'error' && /*#__PURE__*/React.createElement(DismissSmall, {
    className: s.errorIcon
  })))));
};
export const CODE_GEN_STATUS_WIDGET = 'CODE_GEN_STATUS_WIDGET';
//# sourceMappingURL=CodeGenStatus.js.map